import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { LIST_SINGLECAM_AGENT_POOL_QUERY_KEY } from '@/state/queries/singlecam-agent-admin/use-list-singlecam-agent-pool';

export function useForceReleaseSingleCamAgentMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (playerId: string) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/singlecam-agent/actions/force-release`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body: { playerId },
        token: token ?? '',
      }) as Promise<{ released: boolean }>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_SINGLECAM_AGENT_POOL_QUERY_KEY] });
    },
  });
}
